import React, {useState, useContext} from 'react';
import { addMemberToGroup, deleteGroupById, deleteMemberById, getGroups, getMembersByGroupId, postGroups, updateGroupById, updateGroups } from '../api/group';
import {AuthContext} from '../context/AuthContext';

export const useGroup = () => {
    const { setLoading ,checkToken } = useContext(AuthContext);
    const [groups, setGroups] = useState([]);
    const [members, setMembers] = useState([]);

    const loadGroups = async() => {
        checkToken()
        try {
            setLoading(true);
            const {data} =  await getGroups() ;
            setGroups([...data.data.group])
            setLoading(false);
            return [true,data.data.group]
        } catch(error) {
            setLoading(false);
            console.log(error.response.data.code)
            setGroups([])
            return false
        }        
    }

    const updateGroup = async(groupId,data)=>{
        checkToken()
        try {
          setLoading(true);
          const resp= await updateGroupById(groupId,data); 
          ////console.log(data);
          setLoading(false);
          return true
        } catch (e) {
            setLoading(false);
          console.log(e.response.data.code)
          return false
        }
    }

    const postGroup = async({name, description, picture, members})=>{
        checkToken()
        try {
            setLoading(true);
            const {data} =  await postGroups({name, description, picture, members});
            //console.log(data);
            setLoading(false);
            return true

        } catch (e) {
            setLoading(false);
            console.log(e.response)
            return false
        }
    }

    const deleteGroup = async(groupId)=>{
        checkToken()
        try {
            setLoading(true);
            const {data} =  await deleteGroupById(groupId);
            //console.log(data);
            setLoading(false);
            return true
        }
        catch (e) {
            setLoading(false);
            console.log(e.response)
            return false
        }
    }

    const getMembers = async(groupId) => {
        checkToken()
        try {
            setLoading(true);
            const {data} = await getMembersByGroupId(groupId);
            // console.log(data.data)
            setLoading(false);
            setMembers(data.data.members);
            return data.data.members;
        }
        catch (error) {
            setMembers([]);
            setLoading(false)
            console.log(error.response)
            return false
        }  
    }

    const deleteMember = async(groupId, memberId) => {
        checkToken()
        try {
            setLoading(true);
            const {data} = await deleteMemberById(groupId, memberId);
            //console.log(data);
            setLoading(false);
            return true;
        } catch(error){
            setLoading(false);
            console.log(error);
            setMembers([]);
            return false;
        }
    }

    const addMember = async(groupId, data) => {
        checkToken()
        try {
            setLoading(true);
            const resp = await addMemberToGroup(groupId, data);
            //console.log(data);
            setLoading(false);
            return true;
        } catch(error){
            setLoading(false);
            console.log(error);
            return false;
        }
    }
 
    return {
        loadGroups,
        groups,
        updateGroup,
        postGroup,
        getMembers,
        members,
        deleteMember,
        deleteGroup,
        addMember,
        setMembers
    }
}
